/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import BeneAccountStepBank from "../../../../components/Accounts/BeneAccount/BeneAccountCreate/BeneAccountStepBank";
import BeneAccountStepCategories from "../../../../components/Accounts/BeneAccount/BeneAccountCreate/BeneAccountStepCategories";
import BeneAccountStepConfirm from "../../../../components/Accounts/BeneAccount/BeneAccountCreate/BeneAccountStepConfirm";
import BeneAccountStepContact from "../../../../components/Accounts/BeneAccount/BeneAccountCreate/BeneAccountStepContact";
import BeneAccountStepPAN from "../../../../components/Accounts/BeneAccount/BeneAccountCreate/BeneAccountStepPAN";
import { beneCreateAccount } from "../../../../redux/features/accounts/BeneficiaryAccount/createAccount";
import {
  beneBankLookUp,
  beneVerifyThisBank,
  resetBankError,
  resetBeneVerifyThisGst,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { getOwnerAccountIFSCDetails } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import {
  beneLookUp,
  resetBeneData,
  resetPANVerification,
  verifyThisPAN,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
const id = (x) => x;

const BeneficiaryAccountCreate = ({ flow }) => {
  const scrollIt = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const lastVerifiedPanRef = useRef(null);
  const [remPan, setRemPan] = useState();
  const [active, setActive] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const [GSTStatus, setGSTStatus] = useState(null);
  const [direction, setDirection] = useState(null);
  const [recipients, setRecipients] = useState([]);
  const [hideBlock, setHideBlock] = useState(false);
  const [nonArchive, setNonArchive] = useState(false);
  const [lookupNext, setLookupNext] = useState(false);
  const [verifiedPan, setVerifiedPan] = useState(null);
  const [bankUserInfo, setBankUserInfo] = useState([]);
  const [showAccInfo, setShowAccInfo] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  const [hideBankBlock, setBankHideBlock] = useState(false);
  const [bankAccountName, setBankAccountName] = useState("");
  const [createRecipient, setCreateRecipient] = useState([]);
  const [bankLookupNext, setBankLookupNext] = useState(false);
  const [achivedOpenPop, setAchivedOpenPop] = useState(false);
  const [virtualAccount, setVirtualAccount] = useState(false);
  const [showModalPopup, setShowModalPopup] = useState(false);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [isLinkedAccount, setIsLinkedAccount] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [selectedCatFields, setSelectedCatFields] = useState([]);
  const [showRejectTnxPopup, setRejectTxnPopup] = useState(false);
  const [selectedValue, setSelectedValue] = useState("legalname");
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [unachivedOpenPop, setUnachivedOpenPop] = useState(false);
  const [disableCreateNext, setDisableCreateNext] = useState(false);
  const [bankAchivedOpenPop, setBankAchivedOpenPop] = useState(false);
  const [selectedLabelsCreate, setSelectedLabelsCreate] = useState([]);
  const [isNextButtonEnabled, setIsNextButtonEnabled] = useState(false);
  const [isBankLinkedAccount, setIsBankLinkedAccount] = useState(false);
  const [showAlertCategories, setShowAlertCategories] = useState(false);
  const [bankUnachivedOpenPop, setBankUnachivedOpenPop] = useState(false);
  const [manualVirtualAccount, setManualVirtualAccount] = useState(false);
  const [accountNameValidation, setAccountNameValidation] = useState(true);
  const [showRejectAllTxnReson, setShowRejectAllTxnReson] = useState(false);
  const [bankVerificationStatus, setBankVerificationStatus] = useState(false);
  const [bankAccountType, setBankAccountType] = useState({ type: "", id: "" });
  const [newData, setNewData] = useState({
    gstin: "",
  });
  const [contactBol, setContactBol] = useState({
    email: "",
    contact: "",
    accountname: "",
  });
  const [accountType, setAccountType] = useState({
    type: "",
    id: "",
    name: "",
  });
  const [payload, setPayload] = useState({
    bank_account: "",
    ifsc_code: "",
    contact_no: "",
    email_id: "",
    gstin: "",
    name: "",
    categories: "",
    panNumber: "",
    gst_org_name: "",
    account_name: "",
    labels: [],
    recipient_email: "",
    reimbursement_account: flow === "reimbursement" ? true : false,
    reimbursement_user_id: "",
    userName: "",
    userId: "",
    virtual: "",
  });

  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const isIFSCValid =
    payload?.ifsc_code?.length === 11 && ifscRegex.test(payload?.ifsc_code);

  const isBankError = useSelector(
    (state) => state.beneAllVerification.isBankError,
  );

  const animationClass =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const dataReceiveFromContact = (data) => {
    setContactBol(data);
  };
  const steps = [
    "PAN details",
    "Bank details",
    "Contact details",
    "Category, labels and recipients",
    "Confirm and create",
  ];

  const { services, isLoading } = useSelector((state) => state.refreshToken);
  const {
    verifyPAN,
    beneLookData,
    beneLookLoading,
    verifyPANisLoading,
    beneLookError,
  } = useSelector((state) => state.verify);

  const { verifyBank, verifyBankisLoading } = useSelector(
    (state) => state.beneAllVerification,
  );

  const categories = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  ).filter((cat) => cat?.active === "Y");

  const categoriesConfirmPage = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  );

  const { ownerAccIfscData, ownerAccIfscError } = useSelector(
    (state) => state.ownerAllVerification,
  );

  const benebankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );
  const bankStatus = useSelector(
    (state) => state.beneAllVerification.verifyBank,
  );

  const handleOpen = () => {
    setShowModalPopup(true);
  };

  const handleCreateAccount = async () => {
    try {
      setIsButtonDisabled(true);
      let updatedPayload = { ...payload, navigate };

      if (
        selectedFields.length === categoriesConfirmPage.length ||
        selectedFields.length === 0
      ) {
        updatedPayload.categoriesConfirmPage = null;
      } else {
        updatedPayload = {
          ...updatedPayload,
          categoriesConfirmPage: selectedFields.toString(),
        };
      }

      const response = await dispatch(beneCreateAccount(updatedPayload));
      if (response.type.includes("rejected")) {
        navigate(
          "/beneficiary_account_dashboard/create_beneficiary_account/failed",
          {
            state: {
              error: response.payload,
            },
          },
        );
        return;
      }

      const data = response.payload;

      const accountId = data?.beneficiary_accounts?.[0]?.id;

      navigate(
        `/beneficiary_account_dashboard/create_beneficiary_account/success/${accountId}`,
      );
    } catch (error) {
      console.error(error);
      navigate(
        "/beneficiary_account_dashboard/create_beneficiary_account/failed",
        {
          state: {
            error: {
              message: error.message,
            },
          },
        },
      );
    } finally {
      setIsButtonDisabled(false);
    }
  };

  const bankData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  let haveApproved = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "approved";
  });

  let havePending = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "pending";
  });
  let haveBankApproved = bankData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "approved";
  });

  let haveBankPending = bankData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "pending";
  });

  const handleMainCreate = () => {
    if (benebankLookData?.status === undefined && beneLookError === true) {
      handleCreateAccount();
      sessionStorage.setItem("Create BeneAcc Fresh PAN", false);
      sessionStorage.setItem("Create BeneAcc Fresh Bank", false);
      sessionStorage.removeItem("Create BeneAcc Approve and Decline status");
    } else if (
      !haveApproved &&
      !havePending &&
      !haveBankApproved &&
      !haveBankPending
    ) {
      handleCreateAccount();
      sessionStorage.setItem("Create BeneAcc Fresh PAN", false);
      sessionStorage.setItem("Create BeneAcc Fresh Bank", false);
      sessionStorage.removeItem("Create BeneAcc Approve and Decline status");
    } else {
      handleOpen();
      sessionStorage.removeItem("Create BeneAcc Approve and Decline status");
    }
  };
  const handleEnterKeyPress = (e) => {
    if (e.key === "Enter" && activeStep === 3) {
      handleMainCreate();
    }
    if (e.code === "Space") {
      setShowModalPopup(false);
    }
  };

  const renderCreateAccount = () => {
    switch (activeStep) {
      case 0:
        return (
          <BeneAccountStepPAN
            panNumber={payload.panNumber}
            verifiedPan={verifiedPan}
            handlePanChange={handlePanChange}
            panDetails={verifyPAN?.pan_details}
            beneLookData={beneLookData}
            beneLookLoading={beneLookLoading}
            lookupNext={lookupNext}
            setLookupNext={setLookupNext}
            setIsNextButtonEnabled={setIsNextButtonEnabled}
            verifyPANisLoading={verifyPANisLoading}
            setIsArchived={id}
            setIsApproved={id}
            accountType={accountType}
            setAccountType={setAccountType}
            setIsDennied={id}
            setIsPending={id}
            setShutViewAll={id}
            disableCreateNext={disableCreateNext}
            setDisableCreateNext={setDisableCreateNext}
            setShowAction={id}
            isActive={isActive}
            setIsActive={setIsActive}
            beneLookError={beneLookError}
            setHideBlock={setHideBlock}
            setHideCreate={id}
            hideBlock={hideBlock}
            type="createFlow"
            nonArchive={nonArchive}
            setNonArchive={setNonArchive}
            isLinkedAccount={isLinkedAccount}
            setIsLinkedAccount={setIsLinkedAccount}
            unachivedOpenPop={unachivedOpenPop}
            setUnachivedOpenPop={setUnachivedOpenPop}
            achivedOpenPop={achivedOpenPop}
            setAchivedOpenPop={setAchivedOpenPop}
            isButtonDisabled={isButtonDisabled}
            setPayload={setPayload}
            payload={payload}
            showAccInfo={showAccInfo}
            setShowAccInfo={setShowAccInfo}
            handleDeSelectConfirm={handleDeSelectConfirm}
            showRejectTnxPopup={showRejectTnxPopup}
            setRejectTxnPopup={setRejectTxnPopup}
            showRejectAllTxnReson={showRejectAllTxnReson}
            setShowRejectAllTxnReson={setShowRejectAllTxnReson}
            GSTStatus={GSTStatus}
            setGSTStatus={setGSTStatus}
            setNewData={setNewData}
          />
        );
      case 1:
        return (
          <BeneAccountStepBank
            isButtonDisabled={isButtonDisabled}
            setBankIsArchived={id}
            setBankIsApproved={id}
            bankLookupNext={bankLookupNext}
            setBankLookupNext={setBankLookupNext}
            setBankIsPending={id}
            setBankIsDennied={id}
            setIsNextButtonEnabled={setIsNextButtonEnabled}
            activeStep={activeStep}
            payload={payload}
            setPayload={setPayload}
            setBankShutViewAll={id}
            setBankDisableCreateNext={id}
            bankAccountType={bankAccountType}
            setBankAccountType={setBankAccountType}
            active={active}
            setActive={setActive}
            setBankNewMessage={id}
            hideBankBlock={hideBankBlock}
            setBankHideBlock={setBankHideBlock}
            setBankHideCreate={id}
            setBankAchivedOpenPop={setBankAchivedOpenPop}
            bankAchivedOpenPop={bankAchivedOpenPop}
            setBankUnachivedOpenPop={setBankUnachivedOpenPop}
            bankUnachivedOpenPop={bankUnachivedOpenPop}
            setBankUserInfo={setBankUserInfo}
            bankVerificationStatus={bankVerificationStatus}
            setBankVerificationStatus={setBankVerificationStatus}
            isIFSCValid={isIFSCValid}
            isBankError={isBankError}
            virtualAccount={virtualAccount}
            setVirtualAccount={setVirtualAccount}
            isBankLinkedAccount={isBankLinkedAccount}
            setIsBankLinkedAccount={setIsBankLinkedAccount}
            setManualVirtualAccount={setManualVirtualAccount}
            manualVirtualAccount={manualVirtualAccount}
            ownerAccIfscError={ownerAccIfscError}
            ownerAccIfscData={ownerAccIfscData}
            ifscData={ifscData}
          />
        );
      case 2:
        return (
          <BeneAccountStepContact
            payload={payload}
            setPayload={setPayload}
            onSelectFieldsChange={handleSelectFieldsChange}
            setIsNextButtonEnabled={setIsNextButtonEnabled}
            parentCreateBen={dataReceiveFromContact}
            activeStep={activeStep}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            accountNameValidation={accountNameValidation}
            setAccountNameValidation={setAccountNameValidation}
            selectedCatFields={selectedCatFields}
            setSelectedCatFields={setSelectedCatFields}
            flow={flow}
          />
        );
      case 3:
        return (
          <BeneAccountStepCategories
            payload={payload}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={setSelectedLabelsCreate}
            setPayload={setPayload}
            categories={categories}
            onSelectFieldsChange={handleSelectFieldsChange}
            setIsNextButtonEnabled={setIsNextButtonEnabled}
            parentCreateBen={dataReceiveFromContact}
            activeStep={activeStep}
            showAlertCategories={showAlertCategories}
            setShowAlertCategories={setShowAlertCategories}
            handleNext={handleNext}
            flow={flow}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            accountNameValidation={accountNameValidation}
            setAccountNameValidation={setAccountNameValidation}
            selectAllChecked={selectAllChecked}
            setSelectAllChecked={setSelectAllChecked}
            selectedCatFields={selectedCatFields}
            setSelectedCatFields={setSelectedCatFields}
            createRecipient={createRecipient}
            setCreateRecipient={setCreateRecipient}
            recipients={recipients}
            setRecipients={setRecipients}
          />
        );
      case 4:
        return (
          <BeneAccountStepConfirm
            payload={payload}
            selectedFields={selectedFields}
            bankAccountName={bankAccountName}
            setShowModalPopup={setShowModalPopup}
            showModalPopup={showModalPopup}
            bankUserInfo={bankUserInfo}
            recipients={createRecipient}
            flow={flow}
            remPan={remPan}
            setRemPan={setRemPan}
            isSubmitting={isSubmitting}
            setIsSubmitting={setIsSubmitting}
            manualVirtualAccount={manualVirtualAccount}
            handleCreateAccount={handleCreateAccount}
          />
        );
      default:
        return null;
    }
  };

  const handleKeyDown = (event) => {
    if (event.target.tagName === "INPUT") {
    } else if (
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === "Tab" ||
      event.key === " "
    ) {
      event.preventDefault();
    }
  };

  const handleNext = () => {
    if (
      activeStep === 3 &&
      selectedFields?.length === categories?.length &&
      !showAlertCategories
    ) {
      setShowAlertCategories(true);
      setSelectedLabelsCreate(selectedLabelsCreate || []);
    } else if (activeStep === 4) {
      handleMainCreate();
    } else {
      // setButtonDisabled(true);
      setShowAlertCategories(false);
      setActiveStep((prevActiveStep) => prevActiveStep + 1);

      setDirection("next");
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, 1000);
    }
  };

  const handleBack = () => {
    if (activeStep === 0) {
      navigate(-1);
      return;
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setDirection("previous");
    setRemoveClassName(false);
    setTimeout(() => {
      setRemoveClassName(true);
    }, 1000);
  };

  const handleDeSelectConfirm = () => {
    setLookupNext(false);
    setIsNextButtonEnabled(false);
  };

  const handleSelectFieldsChange = (selectedFields) => {
    setSelectedFields(selectedFields);
  };

  const handlePanChange = (e) => {
    let inputPan = e.target.value.toUpperCase();
    inputPan = inputPan.replace(/[^A-Z0-9]/g, "");

    if (inputPan.length > GlobalConfiguration?.panLength) {
      return;
    }

    setVerifiedPan(null);
    lastVerifiedPanRef.current = null;

    setPayload((prev) => ({
      ...prev,
      panNumber: inputPan,
      gstin: "",
      legalName: "",
      account_name: "",
    }));
    dispatch(resetPANVerification());
    dispatch(resetBeneData());

    if (
      !panRegex.test(inputPan) &&
      inputPan.length === GlobalConfiguration.panLength
    ) {
      setVerifiedPan(false);
      dispatch(resetBeneData());
    } else if (inputPan.length === 10) {
      dispatch(resetPANVerification());
      dispatch(verifyThisPAN({ pan_number: inputPan, showToast: false }));
      setGSTStatus(null);
    } else {
      setVerifiedPan(null);
      setIsNextButtonEnabled(false);
      setLookupNext(false);
      setShowAccInfo(false);
    }

    setPayload({ ...payload, panNumber: inputPan, gstin: "" });
    setAccountType({ type: "", id: "", name: "" });

    setDisableCreateNext(false);
    setLookupNext(false);

    setIsActive(false);
    setHideBlock(false);

    dispatch(resetBeneVerifyThisGst());
  };
  const accountHome = () => {
    navigate(-1);
  };

  const commonStepperConfig = {
    previousEnableBgColor: "var(--primary-nav-act)",
    previousDisableBgColor: "var(--primary-nav-act)",
    previousEnableTextColor: "var(--text-primary)",
    previousHoverOption: "white",
    nextEnableBgColor: "var(--text-primary)",
    nextDisableBgColor: "var(--text-disabled)",
    nextEnableTextColor: "var(--primary-bg)",
    nextDisableTextColor: "var(--text-primary)",
    nextHoverOption: "black",
  };

  const dataArray = steps.map((stepLabel, index) => {
    const isFirstStep = index === 0;
    const isLastStep = index === steps.length - 1;
    const accountLoading = isLastStep && isSubmitting;

    return {
      ...commonStepperConfig,
      previousText: isFirstStep ? "Cancel" : "Previous",
      nextText: isLastStep ? "Create" : "Next",
      nextLoaderNeeded: isLastStep,
      nextIsLoading: accountLoading,
      nextIsEnabled: isLastStep
        ? isNextButtonEnabled && !isButtonDisabled && !isSubmitting
        : index === GlobalConfiguration.lengthCheckOne && manualVirtualAccount
          ? true
          : isNextButtonEnabled && !isButtonDisabled,
      nextEnableBgColor: isLastStep
        ? "var(--positive-act)"
        : "var(--text-primary)",
      nextDisableBgColor: isLastStep
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--primary-bg)",
      nextDisableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--text-primary)",
      stepperText: stepLabel,
    };
  });

  const isPanVerified = verifiedPan === true;
  const ifscData = ownerAccIfscData?.ifsc_details?.[0];

  const hasAssociatedAccounts = beneLookData?.status === true;

  const noAssociatedAccounts = beneLookError === true;

  const isGstEmpty =
    payload?.gstin?.length === GlobalConfiguration.lengthCheckZero;

  const isGstVerified =
    payload?.gstin?.length === GlobalConfiguration.gstLength &&
    GSTStatus === true;

  const isGstInvalid =
    payload?.gstin?.length > GlobalConfiguration.lengthCheckZero &&
    !isGstVerified;

  const shouldEnableNextButtonFirstStepper =
    isPanVerified &&
    ((noAssociatedAccounts && (isGstEmpty || isGstVerified)) ||
      (hasAssociatedAccounts && lookupNext)) &&
    !isGstInvalid;

  const isBankStatusValid = bankStatus?.status === true;
  const isBankAccountValid = payload?.bank_account?.length > 0;
  const isIfscCodeValid = payload?.ifsc_code?.length === 11;
  const isVerifyBankValid = verifyBank?.status === true;

  const shouldEnableNextButtonSecondStepper =
    benebankLookData === null
      ? isBankStatusValid &&
        isBankAccountValid &&
        isIfscCodeValid &&
        isVerifyBankValid
      : isBankStatusValid &&
        isBankAccountValid &&
        isIfscCodeValid &&
        isVerifyBankValid &&
        bankLookupNext === true;

  const isContactValid = contactBol.contact === true;
  const isEmailValid = contactBol.email === true;
  const isAccountNameValid = contactBol.accountname === true;

  const shouldEnableNextButtonThirdStepper =
    isContactValid && isEmailValid && isAccountNameValid;

  useEffect(() => {
    if (
      activeStep === GlobalConfiguration.lengthCheckZero &&
      !beneLookLoading
    ) {
      setIsNextButtonEnabled(shouldEnableNextButtonFirstStepper);
    } else if (activeStep === GlobalConfiguration.lengthCheckOne) {
      setIsNextButtonEnabled(
        shouldEnableNextButtonSecondStepper && bankLookupNext,
      );
    } else if (activeStep === GlobalConfiguration.lengthCheckTwo) {
      setIsNextButtonEnabled(shouldEnableNextButtonThirdStepper);
    } else if (activeStep === GlobalConfiguration.lengthCheckThree) {
      setIsNextButtonEnabled(true);
    } else if (activeStep === GlobalConfiguration.lengthCheckFour) {
      setIsNextButtonEnabled(true);
    }
  }, [
    activeStep,
    bankStatus?.status,
    contactBol?.contact,
    contactBol?.email,
    payload?.bank_account,
    payload?.ifsc_code,
    payload?.gstin,
    verifiedPan,
    verifyBank?.status,
    bankLookupNext,
    beneLookData,
    lookupNext,
    shouldEnableNextButtonFirstStepper,
    shouldEnableNextButtonSecondStepper,
    shouldEnableNextButtonThirdStepper,
    beneLookLoading,
    selectedFields,
    categories,
    showAlertCategories,
    manualVirtualAccount,
  ]);

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("BUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "BUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  useEffect(() => {
    if (newData.gstin?.length !== 15) {
      setLookupNext(false);
    }
  }, [payload.gstin]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    setRemPan(payload.panNumber);
    setSelectedValue("legalname");
  }, [payload.panNumber]);

  useEffect(() => {
    document.addEventListener("keydown", handleEnterKeyPress);
    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, []);

  useEffect(() => {
    if (!payload.panNumber) {
      setVerifiedPan(null);
      return;
    }

    const currentPan = payload.panNumber;

    if (lastVerifiedPanRef.current === currentPan) return;

    if (verifyPAN?.status === true) {
      lastVerifiedPanRef.current = currentPan;

      setVerifiedPan(true);

      dispatch(beneLookUp({ pan_number: currentPan }));

      setPayload((prev) => ({
        ...prev,
        legalName: verifyPAN?.pan_details?.full_name,
        account_name: verifyPAN?.pan_details?.full_name,
      }));
    } else if (
      verifyPAN?.status === false &&
      currentPan.length === GlobalConfiguration.panLength
    ) {
      lastVerifiedPanRef.current = currentPan;

      setVerifiedPan(false);
      // CommonToast({
      //   text: Object.values(verifyPAN?.errors || {})?.[0]?.[0],
      //   icon: ICONS.ERROR_WHITE_CIRCLE,
      //   variant: "var(--error)",
      //   buttonNeeded: false,
      // });
    }
  }, [verifyPAN, verifyPANisLoading, payload.panNumber]);

  useEffect(() => {
    if (!verifyBankisLoading) {
      if (verifyBank?.status === true) {
        setBankAccountName(true);
        setBankAccountName(verifyBank?.verification_details[0]?.full_name);
      }
    }
  }, [verifyBank]);

  useEffect(() => {
    dispatch(resetPANVerification());
    setVerifiedPan(null);
  }, []);

  useEffect(() => {
    if (payload.ifsc_code?.length < 11) {
      dispatch(resetBankError());
    }
    if (payload.bank_account?.length < 9) {
      const obj = { ...payload, ifsc_code: "" };
      setPayload(obj);
    }
    if (payload.bank_account?.length === 0 && payload.ifsc_code?.length > 0) {
      const newObj = { ...payload, ifsc_code: "" };
      setPayload(newObj);
      //  setBankVerificationStatus(false);
      setIsNextButtonEnabled(false);
      dispatch(resetBankError());
    }
  }, [payload.ifsc_code, payload.bank_account]);

  useEffect(() => {
    if (createRecipient?.length > 0) {
      setPayload((prev) => ({
        ...prev,
        recipient_email: createRecipient.join(","),
      }));
    } else {
      setPayload((prev) => {
        const updated = { ...prev };
        delete updated.recipient_email;
        return updated;
      });
    }
  }, [createRecipient]);

  useEffect(() => {
    const isValid =
      payload.bank_account?.length >= 9 &&
      payload.ifsc_code?.length === 11 &&
      /^[A-Z]{4}0[A-Z0-9]{6}$/.test(payload.ifsc_code);

    if (!isValid) return;

    const timer = setTimeout(() => {
      dispatch(
        beneVerifyThisBank({
          ifsc_code: payload.ifsc_code,
          bank_account: payload.bank_account,
          legal_name: payload.legalName,
          navigate,
        }),
      );

      dispatch(
        beneBankLookUp({
          ifsc: payload.ifsc_code,
          bank_account_no: payload.bank_account,
        }),
      );
      dispatch(
        getOwnerAccountIFSCDetails({
          search_string: payload?.ifsc_code,
          page_no: GlobalConfiguration?.lengthCheckOne,
          page_size: GlobalConfiguration?.filterResults,
        }),
      );
    }, 400);

    return () => clearTimeout(timer);
  }, [payload.bank_account, payload.ifsc_code]);

  useEffect(() => {
    if (benebankLookData?.status && activeStep === 1) {
      setIsNextButtonEnabled(false);
    }
  }, [benebankLookData]);

  useEffect(() => {
    if (!beneLookLoading) {
      setTimeout(() => {
        if (isIFSCValid && !isBankError) {
          if (
            benebankLookData?.beneficiary_accounts?.length >
            GlobalConfiguration.lengthCheckZero
          ) {
            setBankLookupNext(false);
          } else if (!verifyBankisLoading && verifyBank?.status) {
            setBankLookupNext(true);
          }
        }
      }, GlobalConfiguration.lengthCheckZero);
    }
  }, [
    beneLookLoading,
    benebankLookData,
    isBankError,
    isIFSCValid,
    virtualAccount,
    verifyBankisLoading,
    verifyBank,
  ]);

  return (
    <>
      {showAlertCategories && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopup
            headerTitle={"It is unsafe to proceed"}
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            headerWithIcon={ICONS?.ALERT}
            subtext="Assigning all categories to a single account is highly unsafe.
                  It is recommended to limit the number of categories assigned
                  to the account."
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setShowAlertCategories(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Proceed"
            btnTwoBtnType="button"
            btnTwoHandleFunction={() => handleNext()}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div className="w-width-full flex flex-col items-center h-full-height bg-primary-bg">
        <div className="w-width-full">
          <div className="h-navbar-height hidden Qsmd:block"></div>
          <div className="h-[calc(var(--navbar-breadcrumb-height)-var(--navbar-height))] my-margin-sm Qsmd:my-margin-base"></div>
        </div>

        <div className="flex justify-center items-end !bottom-bottom-base Qsmd:h-stepper-moble-height rounded-t-border-radius-md Qmd:relative Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-md w-screen fixed Qsmd:top-top-base left-left-base z-z-index-overlay">
          <PrimaryStepper
            activeStep={activeStep}
            handleForwardAction={handleNext}
            handleBackwardAction={handleBack}
            dataArray={dataArray}
          />
        </div>

        <div className="flex items-center w-width-full bg-primary-nav py-padding-sm px-padding-md fixed left-left-base top-top-base z-z-index-header Qsmd:hidden rounded-b-border-radius-md">
          <div onClick={accountHome}>
            <SVGComponent
              url={ICONS?.ARROW_LEFT_WHITE}
              color="var(--text-primary)"
              width="var(--icon-sm)"
              height="var(--icon-sm)"
            />
          </div>

          <div className="flex flex-col pl-padding-md gap-gap-xs">
            <p className="text-base font-sans text-text-primary">
              Beneficiary Account
            </p>

            {steps[activeStep] && (
              <p className="text-xs font-sans text-text-primary">
                {steps[activeStep]}
              </p>
            )}
          </div>
        </div>

        <>
          <div
            className="mx-auto overflow-hidden h-full flex flex-col items-center relative w-width-full"
            ref={scrollIt}
          >
            <div className="h-mobile-create-header w-width-full hidden flex-shrink-0"></div>
            <div
              className={`w-width-full overflow-auto Qsmd:pt-padding-lg Qsmd:pb-padding-md pt-padding-base h-full flex justify-center ${
                activeStep === GlobalConfiguration.lengthCheckZero &&
                direction === "next"
                  ? ""
                  : removeClassName === true
                    ? ""
                    : animationClass
              }`}
            >
              {renderCreateAccount()}
            </div>
          </div>
        </>

        <div className="h-stepper-moble-height flex-shrink-0 w-width-full Qsmd:hidden block"></div>
      </div>
    </>
  );
};

export default BeneficiaryAccountCreate;
